/**
 * Resolves a relative image URL to a full URL using the API base URL
 * @param {string} imageUrl - The image URL (can be relative or absolute)
 * @returns {string|null} - The full image URL or null if imageUrl is falsy
 */
export const getFullImageUrl = (imageUrl) => {
  if (!imageUrl) return null;

  // If already a full URL, return as is
  if (
    imageUrl.startsWith("http://") ||
    imageUrl.startsWith("https://") ||
    imageUrl.startsWith("data:")
  ) {
    return imageUrl;
  }

  // Prepend API base URL to relative paths
  const baseUrl = (
    process.env.REACT_APP_API_BASE_URL || "https://kiosk.belinnov.co.in"
  ).replace(/\/+$/, "");
  const normalizedImagePath = String(imageUrl).replace(/^\/+/, "");

  return `${baseUrl}/${normalizedImagePath}`;
};
